import { Region } from "#/store/types";

export type RegionDisplayFunction = (proxy: Region | null) => string;

export const regionToString = (r: Region | null) => (r ? `${r.name} : ${r.lr}` : "Выберите");

export const defaultDF: RegionDisplayFunction = regionToString;
